import type { NodeId } from 'web';
import type { StringArrayData } from '@/types/node';
import type { FlowGraph } from '../FlowGraph';

export class StringArrayView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  private update(updateFn: (data: StringArrayData) => Partial<StringArrayData>) {
    this.graph.wasmEdit((wasm) => {
      const data = this.graph.store.getNodeData<StringArrayData>(this.nodeId);
      const newData = updateFn(data);
      return wasm.setStringArray(this.nodeId, newData.array ?? data.array, newData.delimiter ?? data.delimiter);
    });
    this.graph.updateNodeOutputs(this.nodeId);
  }

  setItem(index: number, value: string) {
    this.update(({ array }) => {
      if (index >= array.length) throw new Error('invalid index');
      const newArray = [...array];
      newArray[index] = value;
      return { array: newArray };
    });
  }

  deleteItem(index: number) {
    this.update(({ array }) => {
      if (index >= array.length) throw new Error('invalid index');
      const newArray = [...array];
      newArray.splice(index, 1);
      return { array: newArray };
    });
  }

  addItem(value: string) {
    this.update(({ array }) => {
      const newArray = [...array, value];
      return { array: newArray };
    });
  }

  setDelimiter(delimiter: string) {
    this.update(() => ({ delimiter }));
  }

  setArray(array: string[]) {
    this.update(() => ({ array }));
  }
}
